import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";

const ThemSuaThuocTinh = ({ tab, data, onClose, onSearch }) => {
    const isSua = !!(data && data.Id > 0);
    const [ten, setTen] = useState(data?.Ten ?? "");
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        const value = (ten || "").trim();
        if (value === "") {
            setError(`Vui lòng nhập ${tab.nhanCot.toLowerCase()}`);
            return;
        }
        setError("");
        try {
            setSaving(true);
            const res = isSua
                ? await CauHinhThongKeKhachHangApi.capNhat({
                      loai: tab.loai,
                      id: data.Id,
                      ten: value,
                  })
                : await CauHinhThongKeKhachHangApi.themMoi({
                      loai: tab.loai,
                      ten: value,
                  });
            if (!res.ok) {
                pushNotification(
                    typeof res.data === "string" && res.data !== ""
                        ? res.data
                        : "Không thể lưu. Vui lòng thử lại!",
                    "error",
                    "TOP_CENTER",
                    2000
                );
                return;
            }
            pushNotification(
                isSua ? "Cập nhật thành công!" : "Thêm mới thành công!",
                "success",
                "TOP_CENTER",
                1000
            );
            onClose();
            onSearch();
        } catch (err) {
            console.error("Lỗi khi lưu cấu hình thống kê khách hàng:", err);
            pushNotification(
                err?.response?.data || "Không thể lưu. Vui lòng thử lại!",
                "error",
                "TOP_CENTER",
                2000
            );
        } finally {
            setSaving(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSave();
        }
    };

    return (
        <Modal
            show={true}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title">
                    <span className="btn-icon-right">
                        <i className="mdi mdi-playlist-edit"></i>
                    </span>
                    {isSua
                        ? `Sửa ${tab.tenThuocTinh}`
                        : `Thêm mới ${tab.tenThuocTinh}`}
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <form className="form form-horizontal" onSubmit={(e) => e.preventDefault()}>
                    <div className="form-body">
                        <div className="form-group row">
                            <label className="col-md-12 label-control text-left">
                                {tab.nhanCot} <span className="red">*</span>
                            </label>
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    autoFocus
                                    maxLength={255}
                                    value={ten}
                                    placeholder={`Nhập ${tab.nhanCot.toLowerCase()}`}
                                    onChange={(e) => {
                                        setTen(e.target.value);
                                        if (error) setError("");
                                    }}
                                    onKeyDown={handleKeyDown}
                                />
                                {error !== "" && (
                                    <small className="red">{error}</small>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                    disabled={saving}
                    onClick={handleSave}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-check"></i>
                    </span>
                    Lưu
                </button>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ThemSuaThuocTinh;
